import { RANK_TOP, SEARCH_TOP, FIRE_TAGS } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  flat: "ri-arrow-right-line",
  down: "ri-arrow-down-line",
};

const trendCls: Record<string, string> = {
  up: "text-primary-600",
  flat: "text-secondary-500",
  down: "text-secondary-400",
};

const tagCls: Record<string, string> = {
  黑料: "bg-primary-100 text-primary-800",
  猛料: "bg-accent-100 text-accent-900",
  内幕: "bg-secondary-100 text-secondary-900",
  曝光: "bg-foreground-100 text-foreground-700",
};

export default function HotZone() {
  return (
    <section id="hot" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="今日热瓜榜 · 实时更"
          title="今天都在扒什么"
          desc="按讨论热度自动排序，每隔 5 分钟刷新一次（示意）。"
          extra={
            <div className="flex items-center gap-1.5 text-[13px] text-foreground-500">
              <span className="relative flex h-2 w-2">
                <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-primary-500" />
              </span>
              实时热度 26,431,092
            </div>
          }
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* rank list */}
          <div className="lg:col-span-8">
            <ol className="divide-y divide-background-200 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70">
              {RANK_TOP.map((r) => {
                const top3 = r.rank <= 3;
                return (
                  <li key={r.rank}>
                    <a
                      href="#feed"
                      className="group flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-100 md:px-5"
                    >
                      <span
                        className={`w-8 shrink-0 text-center font-heading text-xl font-black ${
                          top3 ? "text-primary-600" : "text-foreground-300"
                        }`}
                      >
                        {String(r.rank).padStart(2, "0")}
                      </span>
                      <span
                        className={`shrink-0 rounded px-1.5 py-0.5 text-[12px] font-semibold ${tagCls[r.tag] ?? "bg-secondary-100 text-secondary-900"}`}
                      >
                        {r.tag}
                      </span>
                      <p className="min-w-0 flex-1 truncate text-[15px] font-medium text-foreground-900 group-hover:text-primary-700">
                        {r.title}
                      </p>
                      <span className="hidden shrink-0 items-center gap-1 text-[13px] font-semibold text-primary-600 sm:flex">
                        <i className="ri-fire-fill w-4 h-4 flex items-center justify-center" />
                        {r.heat}
                      </span>
                      <i
                        className={`${trendIcon[r.trend]} hidden w-4 h-4 shrink-0 items-center justify-center md:flex ${trendCls[r.trend]}`}
                      />
                    </a>
                  </li>
                );
              })}
            </ol>
          </div>

          {/* right sidebar: hot keywords + topics */}
          <div className="space-y-6 lg:col-span-4">
            <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/70">
              <h4 className="flex items-center gap-2 font-heading text-[17px] font-black text-foreground-950">
                <i className="ri-search-eye-line text-primary-600 w-5 h-5 flex items-center justify-center" />
                正在搜的关键词
              </h4>
              <div className="mt-4 flex flex-wrap gap-2">
                {SEARCH_TOP.map((k, i) => (
                  <a
                    href="#feed"
                    key={k}
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-[13px] text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-900"
                  >
                    {i < 3 && (
                      <span className="relative flex h-1.5 w-1.5">
                        <span className="absolute inline-flex h-full w-full rounded-full bg-primary-500" />
                      </span>
                    )}
                    {k}
                  </a>
                ))}
              </div>
            </div>

            <div className="overflow-hidden rounded-lg bg-secondary-900 text-background-50">
              <div className="flex items-center justify-between px-5 pt-5">
                <h4 className="flex items-center gap-2 font-heading text-[17px] font-black">
                  <i className="ri-hashtag text-accent-400 w-5 h-5 flex items-center justify-center" />
                  今日爆火话题
                </h4>
                <span className="text-[12px] text-background-50/60">24h</span>
              </div>
              <div className="px-5 py-4">
                {FIRE_TAGS.map((t) => (
                  <a
                    href="#feed"
                    key={t}
                    className="group flex items-center justify-between border-b border-dashed border-background-50/15 py-2.5 text-[14px] text-background-50/90 last:border-0"
                  >
                    <span className="flex items-center gap-2">
                      <i className="ri-chat-voice-line text-accent-400 w-4 h-4 flex items-center justify-center" />
                      <span className="group-hover:text-accent-300">{t}</span>
                    </span>
                    <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-background-50/40" />
                  </a>
                ))}
              </div>
              <a
                href="#report"
                className="flex items-center justify-center gap-1.5 bg-secondary-800 py-3 text-[13px] font-semibold text-background-50/90 transition-colors hover:bg-secondary-700"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center" />
                去围观正在塌的房
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}